import {TABLE_CONFIG_DEFAULT} from '@app/ng-zorro/nz-config/nz-common.config';
import {AppTableConfig} from '@shared/components/app-table/app-table.interfaces';
import {RoleType} from "@modules/administration/administration.const";

export class OrderConstant {

  private static HEADER_TABLE_BASE = [
    {
      title: 'Tên khách hàng',
      field: 'customerName',
      // tdClassList: ['text-center'],
      tdClassList: ['font-weight-semibold'],
      width: 150,
      filterTemplate: 'filter.customerName',
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Địa chỉ',
      field: 'address',
      filterTemplate: 'filter.address',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 150,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Số điện thoại',
      field: 'phoneNumber',
      filterTemplate: 'filter.phoneNumber',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 150,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Sản phẩm',
      field: 'productView',
      filterTemplate: 'filter.product',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 300,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Số tiền',
      field: 'amount',
      pipe: 'currency',
      filterTemplate: 'filter.amount',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 150,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Tiền ship',
      field: 'shipFee',
      pipe: 'currency',
      filterTemplate: 'filter.shipFee',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 150,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Tổng tiền',
      field: 'totalAmount',
      pipe: 'currency',
      filterTemplate: 'filter.totalAmount',
      tdClassList: ['total-amount'],
      // thClassList: ['text-center'],
      width: 150,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Thanh toán',
      field: 'paid',
      filterTemplate: 'filter.paid',
      tdTemplate: 'paidTmpl',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 150,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Đã giao hàng',
      field: 'isShipped',
      filterTemplate: 'filter.isShipped',
      tdTemplate: 'shippedTmpl',
      width: 150,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Kênh bán hàng',
      field: 'channelStr',
      filterTemplate: 'filter.channel',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 150,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Kênh thanh toán',
      field: 'channelPaymentStr',
      filterTemplate: 'filter.channelPayment',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 150,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Ngày tạo',
      field: 'createdDate',
      pipe: 'dateTime',
      filterTemplate: 'filter.createdDate',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 150,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    }
    ,
    {
      title: 'Ngày giao hàng',
      field: 'orderDate',
      pipe: 'dateTime',
      filterTemplate: 'filter.orderDate',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 150,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    // {
    //   title: 'Người cập nhật',
    //   field: 'updateName',
    //   filterTemplate: 'filter.updateName',
    //   // tdClassList: ['text-center'],
    //   // thClassList: ['text-center'],
    //   width: 150,
    //   sort: {
    //     sortDirections: ['ascend', 'descend', null],
    //   }
    // },
    {
      title: 'Ghi chú',
      field: 'moreInfor',
      filterTemplate: 'filter.moreInfor',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 150,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Hành động',
      filterTemplate: 'filter.actionTmpl',
      tdClassList: ['text-center'],
      thClassList: ['text-center'],
      tdTemplate: 'actionTmpl',
      fixed: true,
      fixedDir: "right",
      width: 100
    },
  ];

  public static TABLE_CONFIG: AppTableConfig = {
    headers: [...OrderConstant.HEADER_TABLE_BASE],
    total: 0,
    needScroll: true,
    loading: false,
    pageSize: TABLE_CONFIG_DEFAULT.pageSize,
    pageIndex: 1,
    size: 'small',
    showCheckbox: true,
    showFrontPagination: false,
    showId: true,
    bordered: true,
    showSizeChanger: true,
    showFilter: true
  };
}
